// File: src/utils/scoring.js
// The scoring rules a class may override, as data.
//
// A mirror of SCORING_FIELDS in backend/scoring.js. It carries no arithmetic -
// the server resolves every class against its series before sending it - only
// the list of which rules exist and what each is called on the wire, so the
// settings form can render from it rather than from eight hand-written blocks.
//
// The two ends must agree. A rule added to one and not the other is a control
// that saves nothing, or a column nothing can reach.

export const SCORING_FIELDS = [
  { column: 'total_races', api: 'totalRaces', type: 'int', label: 'totalRaces' },
  { column: 'races_counted', api: 'racesCounted', type: 'int', label: 'racesCounted' },
  { column: 'calculate_qualification_points', api: 'calculateQualificationPoints', type: 'bool', label: 'calculateQualificationPoints' },
  { column: 'qualification_master', api: 'qualificationMaster', type: 'bool', label: 'qualificationMaster' },
  { column: 'senior_championship', api: 'seniorChampionship', type: 'bool', label: 'seniorChampionship' },
  { column: 'senior_age_limit', api: 'seniorAgeLimit', type: 'int', label: 'ageLimit' },
  { column: 'junior_championship', api: 'juniorChampionship', type: 'bool', label: 'juniorChampionship' },
  { column: 'junior_age_limit', api: 'juniorAgeLimit', type: 'int', label: 'ageLimit' }
];
